import { render, staticRenderFns } from "./MaterialTable.vue?vue&type=template&id=c497c1fe&"
import script from "./MaterialTable.vue?vue&type=script&lang=js&"
export * from "./MaterialTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports